(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-grouped-product-grid"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tecmate-collection-filters')) {

  customElements.define('tecmate-collection-filters', class extends HTMLElement {

    connectedCallback() {

      this.filterFrame = requestAnimationFrame(() => this.initializeFilters());

    }



    disconnectedCallback() {

      cancelAnimationFrame(this.filterFrame);

      if (this.filterEvents) this.filterEvents.abort();

    }



    readFilterValues(item, key) {

      let value;

      try {

        value = JSON.parse(item.getAttribute('data-filter-' + key) || 'null');

      } catch (error) {

        return [];

      }

      const values = Array.isArray(value) ? value : [value];

      return values.flatMap((entry) => {

        if (typeof entry !== 'string' && typeof entry !== 'number') return [];

        // Support pasted bullet-separated text as well as native metafield lists.

        // Keep ranges, commas, and slash-separated labels intact.

        return String(entry).split(/[•|\n]/u).map((text) => text.trim()).filter(Boolean);

      });

    }



    initializeFilters() {

      const toolbar = this.querySelector('[data-filter-toolbar]');

      if (!toolbar) return;

      if (this.filterEvents) this.filterEvents.abort();

      this.filterEvents = new AbortController();

      const eventOptions = { signal: this.filterEvents.signal };

      const fields = ['voltage', 'amperage', 'chemistry'];

      const selects = fields.map((key) => toolbar.querySelector('[data-filter-select="' + key + '"]'));

      const records = Array.from(this.querySelectorAll('[data-filter-product]')).map((item) => {

        const terms = {};

        fields.forEach((key) => { terms[key] = this.readFilterValues(item, key); });

        return { item, id: item.dataset.productId, terms };

      });

      const totalProducts = new Set(records.map((record) => record.id)).size;

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

      const normalize = (text) => text.toLocaleLowerCase();



      selects.forEach((select, index) => {

        const key = fields[index];

        const values = new Map();

        records.forEach((record) => record.terms[key].forEach((text) => {

          const value = normalize(text);

          if (!values.has(value)) values.set(value, text);

        }));

        while (select.options.length > 1) select.remove(1);

        const sorted = Array.from(values.entries()).sort((a, b) => {

          if (key !== 'chemistry') {

            const first = parseFloat(a[1]);

            const second = parseFloat(b[1]);

            if (Number.isFinite(first) && Number.isFinite(second) && first !== second) return first - second;

          }

          return collator.compare(a[1], b[1]);

        });

        sorted.forEach(([value, label]) => select.add(new Option(label, value)));

        select.closest('[data-filter-field]').hidden = values.size === 0;

              const field = select.closest('[data-filter-field]');



      // Rebuild chips when the section initializes.

      field.querySelector('[data-filter-chips]')?.remove();



      const chips = document.createElement('div');

      chips.className = 'collection-grid-filters__chips';

      chips.setAttribute('data-filter-chips', '');

      chips.setAttribute('role', 'group');

      chips.setAttribute(

        'aria-label',

        field.querySelector('label').textContent.trim()

      );



      Array.from(select.options).forEach((option) => {

        const button = document.createElement('button');



        button.type = 'button';

        button.className = 'collection-grid-filters__chip';

        button.dataset.filterValue = option.value;

        button.textContent = option.textContent;

        button.setAttribute(

          'aria-pressed',

          String(select.value === option.value)

        );



        button.addEventListener('click', () => {

          select.value = option.value;

          select.dispatchEvent(

            new Event('change', { bubbles: true })

          );

        }, eventOptions);



        chips.append(button);

      });



      field.append(chips);



      // Keep the select as the existing filter's internal value.

      select.hidden = true;

      field.querySelector('label').removeAttribute('for');

      });



      const hasOptions = selects.some((select) => select.options.length > 1);

      toolbar.hidden = !hasOptions;

      const setupMessage = this.querySelector('[data-filter-setup-message]');

      if (setupMessage) setupMessage.hidden = hasOptions;

      if (!hasOptions) return;



      const groups = Array.from(this.querySelectorAll('.industrial-product-group'));

      const navigation = this.querySelector('[data-filter-navigation]');

      const links = navigation ? Array.from(navigation.querySelectorAll('a[href^="#"]')) : [];

      const empty = this.querySelector('[data-filter-empty]');

      const status = toolbar.querySelector('[data-filter-status]');

      const clear = toolbar.querySelector('[data-filter-clear]');

      const update = () => {

        const selected = selects.map((select) => select.value);

              // Update selected styling, including after Clear filters.

      selects.forEach((select) => {

        const buttons = select

          .closest('[data-filter-field]')

          .querySelectorAll('[data-filter-value]');



        buttons.forEach((button) => {

          button.setAttribute(

            'aria-pressed',

            String(button.dataset.filterValue === select.value)

          );

        });

      });

        const active = selected.some(Boolean);

        const matched = new Set();

        records.forEach((record) => {

          const visible = fields.every((key, index) => !selected[index] || record.terms[key].some((term) => normalize(term) === selected[index]));

          record.item.hidden = !visible;

          if (visible) matched.add(record.id);

        });



        let firstVisible = true;

        groups.forEach((group) => {

          const items = Array.from(group.querySelectorAll('[data-filter-product]'));

          const visibleCount = items.filter((item) => !item.hidden).length;

          // Preserve empty-row guidance in the theme editor until a filter is selected.

          group.hidden = active ? visibleCount === 0 : false;

          group.classList.toggle('is-first-visible', !group.hidden && firstVisible);

          if (!group.hidden) firstVisible = false;

          const count = group.querySelector('[data-filter-row-count]');

          if (count) count.textContent = visibleCount + (visibleCount === 1 ? ' product' : ' products');

          links.filter((link) => link.hash === '#' + group.id).forEach((link) => {

            link.closest('li').hidden = group.hidden;

          });

        });

        if (navigation) navigation.hidden = links.every((link) => link.closest('li').hidden);

        if (empty) empty.hidden = !active || matched.size > 0;

        clear.disabled = !active;

        status.textContent = matched.size + ' of ' + totalProducts + (totalProducts === 1 ? ' product' : ' products');

      };

      selects.forEach((select) => select.addEventListener('change', update, eventOptions));

      clear.addEventListener('click', () => {

        selects.forEach((select) => { select.value = ''; });

        update();

      }, eventOptions);

      update();

    }

  });

}


  } catch(e) { console.error(e); }
})();
})();
